<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {};
  },
  props: {
    width: {
      type: Number,
      default: 7
    }
  },
  methods: {
    getUrlParameter: Fandom.getUrlParameter,
    getIframeUrl() {
      const ecmpParams = this.getUrlParameter("ecmp");
      if (ecmpParams) {
        return this.content.iframe_url + "&ecmp=" + ecmpParams;  
      } else {
        return this.content.iframe_url;
      }
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.width;
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="mx-3 mx-md-0 py-4 py-md-5" stripe-iframe-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container">
      <div class="row justify-content-center">
        <div :class="columnClasses">
            <iframe
              frameborder="0" 
              height="500"
              id="contactIFrame"
              :src="getIframeUrl()"
              width="100%">
            </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[stripe-iframe-component] {


}
</style>